import React, { FunctionComponent, useState, useEffect } from 'react';
import type { RecruitmentShowContentModalProps as Props } from './types';
import { FavoriteBtn } from '../../atoms/favoriteBtn';

export const Presentation: FunctionComponent<Props> = (props) => {
  const [activeSection, setActiveSection] = useState<string>('');
  // オブジェクトではなく文字列を渡すようにしている
  const trackingCategory = props.isStopped ? props.dataCategory.stopRecruitmentContent : props.dataCategory.recruitmentContent;

  useEffect(() => {
    const sectionIds = [
      'what-to-do-section',
      'desired-person-section',
      'recruitment-info-section',
      'company-people-section',
      'what-doing-section',
      'company-role-section',
      'company-info-section',
      'company-stories-section',
      'company-mags-section',
      'brand-recruitments-section',
      'company-recruitments-section',
      'occupation-recruitments-section'
    ];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: '-50% 0px -50% 0px', // 画面中央付近でトリガー
        threshold: 0
      }
    );

    sectionIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sectionIds.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  const handleSectionClick = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - 86;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const getSectionDataValue = (sectionId: string): string => {
    switch (sectionId) {
      case 'what-to-do-section': return props.dataValue.whatToDo;
      case 'desired-person-section': return props.dataValue.desiredPerson;
      case 'recruitment-info-section': return props.dataValue.recruitmentInfo;
      case 'company-people-section': return props.dataValue.companyPeople;
      case 'what-doing-section': return props.dataValue.whatDoing;
      case 'company-role-section': return props.dataValue.companyRole;
      case 'company-info-section': return props.dataValue.companyInfo;
      case 'company-stories-section': return props.dataValue.companyStories;
      case 'company-mags-section': return props.dataValue.companyMags;
      case 'brand-recruitments-section': return props.dataValue.brandRecruitments;
      case 'company-recruitments-section': return props.dataValue.companyRecruitments;
      case 'occupation-recruitments-section': return props.dataValue.occupationRecruitments;
      default: return '';
    }
  };

  const getSectionName = (sectionId: string) => {
    switch (sectionId) {
      case 'what-to-do-section': return '何をやるのか';
      case 'desired-person-section': return 'どんな人に来て欲しいか';
      case 'recruitment-info-section': return '募集情報';
      case 'company-people-section': return 'メンバー';
      case 'what-doing-section': return '何をやっているのか';
      case 'company-role-section': return '企業の役割';
      case 'company-info-section': return '会社情報';
      case 'company-stories-section': return 'この企業のストーリー';
      case 'company-mags-section': return 'この企業をもっと知る';
      case 'brand-recruitments-section': return 'このブランドの募集中求人';
      case 'company-recruitments-section': return 'この企業の募集中求人';
      case 'occupation-recruitments-section': return 'この職種の求人';
      default: return '';
    }
  };

  const isLoggedIn = Boolean(props.currentUser || props.isLoggedIn);

  return (
    <aside className="recruitment__show__wrapper__side">
      {isLoggedIn && props.connectedFlag &&
        <a
          href={`/messages/${props.messageBoxId}`}
          className="entry message gtm-button-view-count"
          data-event='click'
          data-category={trackingCategory}
          data-value={props.dataValue.loggedInToMessage}
        >
          <span className="material-symbols-outlined cdn-icon to-message">sms</span>
          メッセージを確認
        </a>
      }
      {props.isStopped && !props.connectedFlag &&
        <a href="javascript:void(0);" className="entry entried">
          募集終了しました
        </a>
      }
      {!props.isStopped && !isLoggedIn &&
        <a
          href="javascript:void(0);"
          className="entry gtm-entry-view-count"
          onClick={props.handleRegisterModalOpen}
          {...(!props.isPreview && {
            'data-event-name': 'entry on screen',
            'data-event': 'click',
            'data-category': trackingCategory,
            'data-value': props.dataValue.notLoginEntry,
            'data-type': 'recruitment',
            'data-state': props.isShowMag ? 'with_mag' : 'no_mag'
          })}
        >
          まずはエントリー
        </a>
      }
      {!props.isStopped && isLoggedIn && !props.connectedFlag &&
        <a
          href="javascript:void(0);"
          className="entry gtm-entry-view-count"
          onClick={props.isPreview ? props.handlePreviewClick : props.handleClickEntry}
          {...(!props.isPreview && {
            'data-event-name': 'entry on screen',
            'data-event': 'click',
            'data-category': trackingCategory,
            'data-value': props.isScouted ? props.dataValue.loggedInScoutEntry : props.dataValue.loggedInEntry,
            'data-state': props.isShowMag ? 'with_mag' : 'no_mag'
          })}
        >
          まずはエントリー
        </a>
      }
      {!props.isCompany &&
        <FavoriteBtn
          recruitmentId={String(props.recruitmentId)}
          isShow={props.isShow}
          isStopped={props.isStopped}
          dataCategory={props.isStopped ? props.dataCategory.stopRecruitmentContent : props.dataCategory.recruitmentContent}
          isPreview={props.isPreview}
        />
      }
      <div className="description gtm-index-view-count" data-event-name='index on screen' data-category={props.isStopped ? props.dataCategory.stopRecruitmentContent : props.dataCategory.recruitmentContent} data-value={props.dataValue.index} data-recruitmentid={props.recruitmentId} data-companyid={props.companyId}>
        {[
          'what-to-do-section',
          'desired-person-section',
          'recruitment-info-section',
          'company-people-section',
          'what-doing-section',
          'company-role-section',
          'company-info-section',
          'company-stories-section',
          'company-mags-section',
          'brand-recruitments-section',
          'company-recruitments-section',
          'occupation-recruitments-section'
          ]
          .filter((sectionId) => document.getElementById(sectionId))
          .map((sectionId) => (
            <a
              key={sectionId}
              href="#"
              className={`description__link ${activeSection === sectionId ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); handleSectionClick(sectionId); }}
              data-event='click'
              data-category={props.isStopped ? props.dataCategory.stopRecruitmentContent : props.dataCategory.recruitmentContent}
              data-value={getSectionDataValue(sectionId)}
              data-recruitmentid={props.recruitmentId}
              data-companyid={props.companyId}
            >
              {getSectionName(sectionId)}
            </a>
          ))}
      </div>
    </aside>
  );
};
